import script from "./training.vue?vue&type=script&setup=true&lang=js"
export * from "./training.vue?vue&type=script&setup=true&lang=js"

import "./training.vue?vue&type=style&index=0&id=b5799056&lang=less&scoped=true"

import exportComponent from "D:\\openAi\\chinese-academy-of-sciences-home\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b5799056"]])

export default __exports__